import styled from 'styled-components'

import { Align } from './common.types'
import { PageSectionBlock } from './PageSectionBlock'

interface Props {
  align?: Align
  alignChildren?: string
  flex?: string | number
  flexChildren?: boolean
  spaced?: boolean
  spacedBottom?: boolean
  fillPage?: boolean
}

export const PageSection = styled.div.attrs(({ className }) => ({
  className: 'fic-page-section ' + className,
}))<Props>`
  text-align: ${(props) => props.align};
  float: ${(props) => (props.align === 'center' ? 'none' : props.align)};
  flex: ${(props) => (props.fillPage ? 1 : undefined)};
  align-items: ${(props) => props.alignChildren};
  overflow-y: ${(props) => (props.fillPage ? 'hidden' : undefined)};
  margin-top: ${(props) => (props.spaced ? '15px' : 0)};
  margin-bottom: ${(props) => (props.spacedBottom ? '15px' : 0)};
  display: ${(props) => (props.flexChildren ? 'inline-flex' : 'inline-block')};
  width: 100%;
  ${PageSectionBlock} + ${PageSectionBlock} + ${PageSectionBlock} {
    margin-left: 8px;
  }
  a.btn-flat + a.btn-flat {
    margin-left: 8px;
  }
`

PageSection.defaultProps = {
  align: 'center',
  flexChildren: false,
  spaced: false,
  spacedBottom: false,
  fillPage: false,
}

export const SectionsBoxes = styled(PageSection)`
  margin: 30px 0;
  .fic-page-section-block {
    width: auto;
    max-width: 840px;
    @media all and (-ms-high-contrast: none) {
      max-width: 945px;
    }
    margin: 0 auto;
    display: flex;
    @media screen and (max-width: 799px) {
      justify-content: center;
    }
    flex-flow: row wrap;
    justify-content: left;
    &:after {
      content: '';
      flex: 0 0 255px;
      margin: 25px 12.5px 0;
    }
  }
`

export const DraggableContent = styled.div`
  max-width: 840px;
  text-align: left;
  margin: 30px auto 50px auto;
`
